import AppTheme from 'docs/src/modules/components/AppTheme';
import SignIn from 'docs/src/pages/premium-themes/onepirate/SignIn';

export default function Page() {
  return (
    <AppTheme title="Onepirate theme - MUI" description="A onepirate theme">
      <SignIn />
    </AppTheme>
  );
}
